import { render, staticRenderFns } from "./HomeComponent.vue?vue&type=template&id=74f9bca2"
import script from "./HomeComponent.vue?vue&type=script&lang=js"
export * from "./HomeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports